var Label = require('./base');

module.exports = Label;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_component@0.3.8@@antv/component/lib/label/index.js
// module id = 333
// module chunks = 0 1 2